var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidIcons186Upload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-width:3px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_186_-_UPLOAD",
    "data-name": "186 - UPLOAD"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.74,
    y1: 48.19,
    x2: 63.74,
    y2: 94.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.74,
    y1: 48.19,
    x2: 48.47,
    y2: 63.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.68,
    y1: 48.19,
    x2: 78.96,
    y2: 63.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79,79.44h7.66a15.27,15.27,0,1,0,0-30.54A22.9,22.9,0,0,0,45.71,34.74,11.43,11.43,0,0,0,30.13,49.2a15.27,15.27,0,0,0,3,30.24H48.44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidIcons186Upload);
export default __webpack_public_path__ + "static/media/hid-icons_186-UPLOAD.3022122b8183e8870714b691a41a88bc.svg";
export { ForwardRef as ReactComponent };